import { createSlice } from "@reduxjs/toolkit";

import { DateFns } from "../../../../../utils/DateFns";
import { ReduxReducer } from "../../../../interface";
import { Accounting } from "../../interface";

import { State } from "./interface";

const baseDateFns = new DateFns();

const initialState: State = {
	dateRange: {
		from: baseDateFns.startDate(),
		to: baseDateFns.endDate(),
	},
	query: "",
	callSigns: ["all"],
	companyIds: ["all"],
	taxiServiceIds: ["all"],
	executorIds: ["all"],
	fleetIds: ["all"],
	executorGroupIds: [],
	isSortMap: false,
	isFirstOpenPage: true,
};

const setIsFirstOpenPage: ReduxReducer<State, State["isFirstOpenPage"]> = (
	state,
	{ payload },
) => {
	state.isFirstOpenPage = payload;
};

const setIsSortMap: ReduxReducer<State, State["isSortMap"]> = (
	state,
	{ payload },
) => {
	state.isSortMap = payload;
};

const setQuery: ReduxReducer<State, State["query"]> = (state, { payload }) => {
	state.query = payload;
};

const setDateRange: ReduxReducer<State, State["dateRange"]> = (
	state,
	{ payload },
) => {
	state.dateRange = payload;
};

const setCallSigns: ReduxReducer<State, State["callSigns"]> = (
	state,
	{ payload },
) => {
	state.callSigns = payload;
};
const setCompanyIds: ReduxReducer<State, State["companyIds"]> = (
	state,
	{ payload },
) => {
	state.companyIds = payload;
};

const setTaxiServiceIds: ReduxReducer<State, State["taxiServiceIds"]> = (
	state,
	{ payload },
) => {
	state.taxiServiceIds = payload;
};

const setExecutorIds: ReduxReducer<State, State["executorIds"]> = (
	state,
	{ payload },
) => {
	state.executorIds = payload;
};

const setExecutorGroupIds: ReduxReducer<State, State["executorGroupIds"]> = (
	state,
	{ payload },
) => {
	state.executorGroupIds = payload;
};

const setFleetIds: ReduxReducer<State, State["fleetIds"]> = (
	state,
	{ payload },
) => {
	state.fleetIds = payload;
};

const reset: ReduxReducer<State, any> = (state) => {
	Object.keys(initialState).forEach((key) => {
		state[key] = initialState[key];
	});
};

const filters = createSlice({
	name: Accounting.ConstantAccountingSlice.EXECUTORS_FILTERS,
	initialState,
	reducers: {
		reset,
		setDateRange,
		setQuery,
		setCallSigns,
		setCompanyIds,
		setExecutorIds,
		setTaxiServiceIds,
		setExecutorGroupIds,
		setFleetIds,
		setIsSortMap,
		setIsFirstOpenPage,
	},
});

export const filtersAction = filters.actions;
export const filtersReducer = filters.reducer;
export type filtersState = State;

export default filters;
